<template>
    <div>
        <LoaderComponent v-if="loading > 0" />
        <div v-else>
            <div class="row mb-3" v-if="product.type === 'single'">
                <div class="col-12">
                    <div class="border-light b-radius-20 p-4">
                        <div class="row">
                            <div class="col-md-5">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.modals.productType") }}</label>
                            </div>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="radio">
                                            <label class="form-label container-box">
                                                <input type="radio" v-model="product.single_type" value="single" />
                                                <span class="checkmark"></span> {{ $tl("labels.clickAndCollect.modals.simpleProduct") }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-1">
                                        <div class="radio">
                                            <label class="form-label container-box">
                                                <input type="radio" v-model="product.single_type" value="menu" />
                                                <span class="checkmark"></span> {{ $tl("labels.clickAndCollect.modals.formulaProduct") }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-1">
                                        <div class="radio">
                                            <label class="form-label container-box">
                                                <input type="radio" v-model="product.single_type" value="both" />
                                                <span class="checkmark"></span> {{ $tl("labels.clickAndCollect.modals.both") }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <div class="border-light b-radius-20 p-4">
                        <div class="row mb-2">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.form.name") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <input type="text" maxlength="70" class="form-control" v-model="product.name" />
                                <small class="text-muted">
                                    {{ $tcl("labels.form.textarea.nbActualChars", product.name?.length || 0, { count: product.name?.length || 0 }) }}
                                </small>
                                <small class="text-muted">{{ $tl("labels.form.textarea.maxChars70") }}</small>
                                <ShowErrors class="d-block" :errors="errors" errorKey="name" />
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.form.description") }}</label>
                            </div>
                            <div class="col-md-7">
                                <textarea class="form-control" rows="3" v-model="product.description"></textarea>
                                <ShowErrors :errors="errors" errorKey="description" />
                            </div>
                        </div>
                        <div class="row mb-2 badge-allergens" v-if="product.type !== 'menu'">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.form.allergens") }}</label>
                            </div>
                            <div class="col-md-7">
                                <div class="d-inline-block align-middle lead-switch pt-1 mb-2">
                                    <input
                                        type="checkbox"
                                        class="switch align-self-center is-rounded"
                                        :true-value="true"
                                        :false-value="false"
                                        v-model="product.enable_allergens" />
                                    <label class="form-label" @click="product.enable_allergens = !product.enable_allergens"></label>
                                </div>
                                <template v-if="product.enable_allergens">
                                    <div>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Gluten') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Gluten')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.gluten") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Crustacé') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Crustacé')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.crustacean") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Oeuf') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Oeuf')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.egg") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Poisson') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Poisson')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.fish") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Arachide') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Arachide')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.peanut") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Soja') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Soja')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.soy") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Lait') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Lait')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.milk") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Fruit à coque') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Fruit à coque')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.treeNut") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Céleri') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Céleri')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.celery") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Moutarde') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Moutarde')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.mustard") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Sésame') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Sésame')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.sesame") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Sulfite') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Sulfite')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.sulfite") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Lupin') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Lupin')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.lupin") }}
                                        </span>
                                        <span
                                            class="badge text-bg-secondary p-1 ps-2 pe-2 m-1"
                                            v-bind:class="[isAllergenActive('Mollusque') ? 'active-badge' : '']"
                                            @click="toggleAllergen('Mollusque')">
                                            {{ $tl("labels.clickAndCollect.modals.allergens.mollusk") }}
                                        </span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="row mb-2" v-if="product.single_type !== 'menu'">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.booking.services.category") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <select class="form-select align-middle d-inline-block" v-model="product.cc_products_category_id">
                                    <option :value="null">--</option>
                                    <option v-for="category in products_categories" :key="category.id" :value="category.id">
                                        {{ category.name }}
                                    </option>
                                    <option :value="-1">{{ $tl("labels.custom") }}</option>
                                </select>
                                <input
                                    v-if="product.cc_products_category_id === -1"
                                    type="text"
                                    v-model="custom_category_name"
                                    class="form-control" />
                                <ShowErrors :errors="errors" errorKey="cc_products_category_id" />
                                <ShowErrors :errors="errors" errorKey="custom_category_name" />
                            </div>
                        </div>
                        <div class="row mb-2" v-if="product.single_type !== 'menu'">
                            <div class="col-md-5 pt-1">
                                <label class="form-label mb-0"
                                    >{{ $tl("labels.form.picture") }} <small>{{ $tl("labels.form.recommended") }}</small></label
                                ><br />
                            </div>
                            <div class="col-md-7">
                                <image-uploader
                                    :public-image-uri="product.img !== null ? product.img.public_uri : null"
                                    :image-path="product.img !== null ? product.img.path : null"
                                    :upload-uri="imgPostUri"
                                    :delete-uri="imgPostUri"
                                    @image-uploaded="product.img = $event"
                                    @image-deleted="product.img = null"
                                    :maxSize="10" />
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.modals.ttcPrice") }} <small>*</small></label
                                ><br />
                                <small class="text-warning" v-if="product.single_type == 'menu' && !isTvaDisabled">
                                    {{ $tl("infos.product.ttcPrice") }}
                                </small>
                            </div>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-4">
                                        <input type="number" class="form-control" v-model="product.price" />
                                    </div>
                                    <div class="col-md-8 mt-1">euros</div>
                                    <ShowErrors class="col-12" :errors="errors" errorKey="price" />
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2" v-if="product.single_type !== 'menu'">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.modals.ttcPricePromo") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-inline-block align-middle lead-switch">
                                            <input
                                                type="checkbox"
                                                class="switch align-self-center is-rounded"
                                                :true-value="true"
                                                :false-value="false"
                                                v-model="product.enable_price_offer" />
                                            <label class="form-label" @click="product.enable_price_offer = !product.enable_price_offer"></label>
                                        </div>
                                    </div>
                                    <template v-if="product.enable_price_offer">
                                        <div class="col-12 mt-1">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <input type="number" class="form-control" v-model="product.price_offer" />
                                                </div>
                                                <div class="col-md-8 mt-1">{{ $tl("labels.euros") }}</div>
                                                <ShowErrors class="col-12" :errors="errors" errorKey="price_offer" />
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="date-resa-cal">
                                                <span class="d-block">{{ $tl("labels.from") }}</span>
                                                <datepicker
                                                    format="dd/MM/yyyy"
                                                    calendar-class="positition-relative mt-2"
                                                    :disabled-dates="disabledDates"
                                                    class="w-auto d-inline-block"
                                                    :monday-first="true"
                                                    :language="fr"
                                                    v-model="product.offer_starts_on">
                                                </datepicker>
                                                <feather type="x" class="text-danger pointer" @click="product.offer_starts_on = null" />
                                                <span class="d-block">{{ $tl("labels.to") }}</span>
                                                <datepicker
                                                    format="dd/MM/yyyy"
                                                    calendar-class="positition-relative mt-2"
                                                    :disabled-dates="disabledDates"
                                                    class="w-auto d-inline-block"
                                                    :monday-first="true"
                                                    :language="fr"
                                                    v-model="product.offer_ends_on">
                                                </datepicker>
                                                <feather type="x" class="text-danger pointer" @click="product.offer_ends_on = null" />
                                            </div>
                                        </div>
                                        <ShowErrors class="col-12" :errors="errors" errorKey="offer_starts_on" />
                                        <ShowErrors class="col-12" :errors="errors" errorKey="offer_ends_on" />
                                    </template>
                                    <ShowErrors class="col-12" :errors="errors" errorKey="enable_price_offer" />
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2" v-if="!isTvaDisabled">
                            <div class="col-md-5 pt-1">
                                <label class="form-label mb-0">{{ $tl("labels.to") }} <small>*</small></label
                                ><br />
                                <small>
                                    <a href="https://www.service-public.fr/professionnels-entreprises/vosdroits/F23567" target="_blank">
                                        <feather type="info" class="text-warning me-1" />
                                        {{ $tl("labels.clickAndCollect.modals.vatLegislation") }}
                                    </a>
                                </small>
                            </div>
                            <div class="col-md-7">
                                <div class="row" v-if="product.type === 'single'">
                                    <div class="col-md-4">
                                        <select class="form-select align-middle d-inline-block mb-0" v-model="product.tax_rate">
                                            <option :value="null">--</option>
                                            <option :value="5.5">{{ $tl("labels.clickAndCollect.payments.tableColumns.vat5_5") }}</option>
                                            <option :value="10">{{ $tl("labels.clickAndCollect.payments.tableColumns.vat10") }}</option>
                                            <option :value="20">{{ $tl("labels.clickAndCollect.payments.tableColumns.vat20") }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-8 mt-1">%</div>
                                    <ShowErrors class="col-12" :errors="errors" errorKey="tax_rate" />
                                </div>
                                <span class="text-warning d-block mt-1" v-else>{{ $tl("labels.clickAndCollect.modals.vatRateAutoCalculated") }}</span>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.products.tableColumns.stock") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-4">
                                        <select
                                            class="form-select align-middle d-inline-block mb-0"
                                            style="width: initial"
                                            v-model="product.stock_type"
                                            :disabled="product_stock_nolimit"
                                            :class="{ disabled: product_stock_nolimit }">
                                            <option :value="DAILY_STOCK.value">{{ DAILY_STOCK.label }}</option>
                                            <option :value="GENERAL_STOCK.value">{{ GENERAL_STOCK.label }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-4">
                                        <input :disabled="product_stock_nolimit" type="number" class="form-control" v-model="product.stock" />
                                    </div>
                                    <div class="col-md-4 mt-1">
                                        <label class="form-label container-box" style="width: initial">
                                            <input type="checkbox" v-model="product_stock_nolimit" />
                                            <span class="checkmark"></span> {{ $tl("labels.unlimited") }}
                                        </label>
                                    </div>
                                    <ShowErrors class="col-12" :errors="errors" errorKey="stock" />
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2" v-if="config.is_click_and_collect_enabled">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.modals.clickAndCollectEnabled") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <div class="d-inline-block align-middle lead-switch">
                                    <input
                                        type="checkbox"
                                        class="switch align-self-center is-rounded"
                                        :true-value="true"
                                        :false-value="false"
                                        v-model="product.is_enabled_for_click_and_collect" />
                                    <label
                                        class="form-label"
                                        @click="product.is_enabled_for_click_and_collect = !product.is_enabled_for_click_and_collect"></label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2" v-if="config.is_delivery_enabled">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.modals.deliveryEnabled") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <div class="d-inline-block align-middle lead-switch">
                                    <input
                                        type="checkbox"
                                        class="switch align-self-center is-rounded"
                                        :true-value="true"
                                        :false-value="false"
                                        v-model="product.is_enabled_for_delivery" />
                                    <label class="form-label" @click="product.is_enabled_for_delivery = !product.is_enabled_for_delivery"></label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2" v-if="config.is_dispatch_enabled">
                            <div class="col-md-5 pt-1">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.modals.dispatchEnabled") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <div class="d-inline-block align-middle lead-switch">
                                    <input
                                        type="checkbox"
                                        class="switch align-self-center is-rounded"
                                        :true-value="true"
                                        :false-value="false"
                                        v-model="product.is_enabled_for_dispatch" />
                                    <label class="form-label" @click="product.is_enabled_for_dispatch = !product.is_enabled_for_dispatch"></label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2" v-if="product.is_enabled_for_dispatch">
                            <div class="col-md-5">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.modals.productWeight") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <div class="row" v-if="product.type === 'single'">
                                    <div class="col-md-4">
                                        <input type="number" class="form-control" v-model="product.weight" />
                                    </div>
                                    <div class="col-md-8 mt-1">{{ $tl("labels.clickAndCollect.modals.grams") }}</div>
                                    <ShowErrors class="col-12" :errors="errors" errorKey="weight" />
                                </div>
                                <span class="text-warning d-block mt-1" v-else>{{ $tl("labels.clickAndCollect.modals.formulaWeightAutoCalc") }}</span>
                            </div>
                        </div>
                        <div class="row mb-2" v-if="product.type === 'single' && hasMealVouchersEnabled && isNoShow">
                            <div class="col-md-5">
                                <label class="form-label">{{ $tl("labels.clickAndCollect.modals.payableWithMealVoucher") }} <small>*</small></label>
                            </div>
                            <div class="col-md-7">
                                <div class="d-inline-block align-middle lead-switch">
                                    <input
                                        type="checkbox"
                                        class="switch align-self-center is-rounded"
                                        :true-value="true"
                                        :false-value="false"
                                        v-model="product.payable_with_mealvouchers" />
                                    <label class="form-label" @click="product.payable_with_mealvouchers = !product.payable_with_mealvouchers"></label>
                                </div>
                                <ShowErrors class="d-block" :errors="errors" errorKey="payable_with_mealvouchers" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="row mb-3"
                v-if="product.single_type !== 'menu' && product.is_enabled_for_click_and_collect && config.is_click_and_collect_enabled">
                <div class="col-12">
                    <div class="border-light b-radius-20 p-4">
                        <div class="row" style="cursor: pointer" @click="showCollectParams = !showCollectParams">
                            <div class="col-12">
                                <strong>{{ $tl("labels.clickAndCollect.modals.pickupOptions") }}</strong>
                            </div>
                        </div>
                        <template v-if="showCollectParams">
                            <div class="row mt-3 mb-2">
                                <div class="col-md-5">
                                    <label class="form-label"
                                        >{{ $tl("labels.clickAndCollect.modals.productPreparationDelay") }} <small>*</small></label
                                    >
                                </div>
                                <div class="col-md-7">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="radio">
                                                <label class="form-label container-box"
                                                    ><input type="radio" v-model="productPreparationTime" :value="false" />
                                                    <span class="checkmark"></span>{{ $tl("labels.useDefaultParams") }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 d-inline radio mt-1">
                                            <label class="form-label container-box d-inline-block pt-0 mt-2" style="width: initial"
                                                ><input type="radio" v-model="productPreparationTime" :value="true" /> <span class="checkmark"></span
                                                >{{ $tl("labels.custom") }}
                                            </label>
                                            <template v-if="productPreparationTime">
                                                <input
                                                    type="number"
                                                    class="form-control d-inline-block ms-2 me-2"
                                                    v-model="product.preparation_time"
                                                    style="width: 120px" />
                                                <select
                                                    class="form-select align-middle d-inline-block mb-0"
                                                    style="width: initial"
                                                    v-model="product.preparation_time_unit">
                                                    <option value="mins">{{ $tl("labels.clickAndCollect.settings.delivery.select.mins") }}</option>
                                                    <option value="hours">{{ $tl("labels.clickAndCollect.settings.delivery.select.hours") }}</option>
                                                    <option value="days">{{ $tl("labels.clickAndCollect.settings.delivery.select.days") }}</option>
                                                </select>
                                            </template>
                                        </div>
                                        <ShowErrors class="col-12" :errors="errors" errorKey="preparation_time" />
                                        <ShowErrors class="col-12" :errors="errors" errorKey="preparation_time_unit" />
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3 mb-2">
                                <div class="col-md-5">
                                    <label class="form-label"
                                        >{{ $tl("labels.clickAndCollect.modals.productAvailabilityDates") }} <small>*</small></label
                                    >
                                </div>
                                <div class="col-md-7">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="radio">
                                                <label class="form-label container-box"
                                                    ><input type="radio" v-model="productAvailabilityDate" :value="false" />
                                                    <span class="checkmark"></span>{{ $tl("labels.unlimited") }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 d-inline radio mt-1">
                                            <label class="form-label container-box d-inline-block pt-0 mt-2" style="width: initial"
                                                ><input type="radio" v-model="productAvailabilityDate" :value="true" /> <span class="checkmark"></span
                                                >{{ $tl("labels.limited") }}
                                            </label>
                                            <template v-if="productAvailabilityDate">
                                                <div class="date-resa-cal">
                                                    {{ $tl("labels.filters.dates.from") }}
                                                    <datepicker
                                                        format="dd/MM/yyyy"
                                                        calendar-class="positition-relative mt-2"
                                                        :disabled-dates="disabledDates"
                                                        input-class="w-auto d-inline-block"
                                                        :monday-first="true"
                                                        :language="fr"
                                                        v-model="product.available_from">
                                                    </datepicker>
                                                    {{ $tl("labels.filters.dates.to") }}
                                                    <datepicker
                                                        format="dd/MM/yyyy"
                                                        calendar-class="positition-relative mt-2"
                                                        :disabled-dates="disabledDates"
                                                        input-class="w-auto d-inline-block"
                                                        :monday-first="true"
                                                        :language="fr"
                                                        v-model="product.available_to">
                                                    </datepicker>
                                                </div>
                                                <ShowErrors class="col-12" :errors="errors" errorKey="available_from" />
                                                <ShowErrors class="col-12" :errors="errors" errorKey="available_to" />
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-5">
                                    <label class="form-label"
                                        >{{ $tl("labels.clickAndCollect.modals.productAvailabilitySlots") }} <small>*</small></label
                                    >
                                </div>
                                <div class="col-md-7">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="radio">
                                                <label class="form-label container-box"
                                                    ><input type="radio" v-model="defaultSlots" :value="true" /> <span class="checkmark"></span
                                                    >{{ $tl("labels.useDefaultParams") }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 d-inline radio mt-1">
                                            <label class="form-label container-box d-inline-block pt-0 mt-2" style="width: initial"
                                                ><input type="radio" v-model="defaultSlots" :value="false" /> <span class="checkmark"></span
                                                >{{ $tl("labels.custom") }}
                                            </label>
                                        </div>
                                        <ShowErrors class="col-12" :errors="errors" errorKey="use_default_slots" />
                                    </div>
                                </div>
                            </div>
                            <template v-if="!defaultSlots">
                                <div class="row mt-3">
                                    <div class="offset-1 col-11 pt-2">
                                        <div v-for="day in allDays" :key="day">
                                            <div class="mb-2">
                                                <label class="form-label container-box" style="margin-bottom: 0; width: 100%">
                                                    <input type="checkbox" v-model="active[day]" />
                                                    <span class="checkmark"></span> {{ dayLabel(day, true) }}
                                                </label>
                                            </div>
                                            <div class="setting-open" v-if="active[day]">
                                                <div class="setting-hours">
                                                    <span>
                                                        <div v-for="service in services[day]" :key="service.id">
                                                            <input
                                                                type="text"
                                                                class="form-control d-inline-block"
                                                                style="max-width: 60px"
                                                                :disabled="true"
                                                                :value="service.start_hour" />
                                                            <input
                                                                type="text"
                                                                class="form-control d-inline-block"
                                                                style="max-width: 60px"
                                                                :disabled="true"
                                                                :value="service.end_hour" />
                                                            <label
                                                                v-for="slot in service.slots"
                                                                :key="slot.id"
                                                                class="form-label container-box ms-4"
                                                                style="width: initial">
                                                                <input type="checkbox" v-model="slot.enabled" :true-value="1" />
                                                                <span class="checkmark"></span>
                                                                {{ slot.hour.replace(":", "h").substr(0, 5) }}
                                                            </label>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
            <div class="row mb-3" v-if="product.single_type !== 'menu' && product.is_enabled_for_delivery && config.is_delivery_enabled">
                <div class="col-12">
                    <div class="border-light b-radius-20 p-4">
                        <div class="row" style="cursor: pointer" @click="showDeliveryParams = !showDeliveryParams">
                            <div class="col-12">
                                <strong>{{ $tl("labels.clickAndCollect.modals.deliveryOptions") }}</strong>
                            </div>
                        </div>
                        <template v-if="showDeliveryParams">
                            <div class="row mt-3 mb-2">
                                <div class="col-md-5">
                                    <label class="form-label"
                                        >{{ $tl("labels.clickAndCollect.modals.productPreparationDelay") }} <small>*</small></label
                                    >
                                </div>
                                <div class="col-md-7">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="radio">
                                                <label class="form-label container-box"
                                                    ><input type="radio" v-model="productDeliveryPreparationTime" :value="false" />
                                                    <span class="checkmark"></span>{{ $tl("labels.useDefaultParams") }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 d-inline radio mt-1">
                                            <label class="form-label container-box d-inline-block pt-0 mt-2" style="width: initial"
                                                ><input type="radio" v-model="productDeliveryPreparationTime" :value="true" />
                                                <span class="checkmark"></span>{{ $tl("labels.custom") }}
                                            </label>
                                            <template v-if="productDeliveryPreparationTime">
                                                <input
                                                    type="number"
                                                    class="form-control d-inline-block ms-2 me-2"
                                                    v-model="product.delivery_preparation_time"
                                                    style="width: 120px" />
                                                <select
                                                    class="form-select align-middle d-inline-block mb-0"
                                                    style="width: initial"
                                                    v-model="product.delivery_preparation_time_unit">
                                                    <option value="mins">{{ $tl("labels.clickAndCollect.settings.delivery.select.mins") }}</option>
                                                    <option value="hours">{{ $tl("labels.clickAndCollect.settings.delivery.select.hours") }}</option>
                                                    <option value="days">{{ $tl("labels.clickAndCollect.settings.delivery.select.days") }}</option>
                                                </select>
                                            </template>
                                        </div>
                                        <ShowErrors class="col-12" :errors="errors" errorKey="delivery_preparation_time" />
                                        <ShowErrors class="col-12" :errors="errors" errorKey="delivery_preparation_time_unit" />
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3 mb-2">
                                <div class="col-md-5">
                                    <label class="form-label"
                                        >{{ $tl("labels.clickAndCollect.modals.productAvailabilityDates") }} <small>*</small></label
                                    >
                                </div>
                                <div class="col-md-7">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="radio">
                                                <label class="form-label container-box"
                                                    ><input type="radio" v-model="productDeliveryAvailabilityDate" :value="false" />
                                                    <span class="checkmark"></span>{{ $tl("labels.unlimited") }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 d-inline radio mt-1">
                                            <label class="form-label container-box d-inline-block pt-0 mt-2" style="width: initial"
                                                ><input type="radio" v-model="productDeliveryAvailabilityDate" :value="true" />
                                                <span class="checkmark"></span>{{ $tl("labels.limited") }}
                                            </label>
                                            <template v-if="productDeliveryAvailabilityDate">
                                                <div class="date-resa-cal">
                                                    {{ $tl("labels.filters.dates.from") }}
                                                    <datepicker
                                                        format="dd/MM/yyyy"
                                                        calendar-class="positition-relative mt-2"
                                                        :disabled-dates="disabledDates"
                                                        input-class="w-auto d-inline-block"
                                                        :monday-first="true"
                                                        :language="fr"
                                                        v-model="product.delivery_available_from">
                                                    </datepicker>
                                                    {{ $tl("labels.filters.dates.to") }}
                                                    <datepicker
                                                        format="dd/MM/yyyy"
                                                        calendar-class="positition-relative mt-2"
                                                        :disabled-dates="disabledDates"
                                                        input-class="w-auto d-inline-block"
                                                        :monday-first="true"
                                                        :language="fr"
                                                        v-model="product.delivery_available_to">
                                                    </datepicker>
                                                </div>
                                                <ShowErrors class="col-12" :errors="errors" errorKey="delivery_available_from" />
                                                <ShowErrors class="col-12" :errors="errors" errorKey="delivery_available_to" />
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-5">
                                    <label class="form-label"
                                        >{{ $tl("labels.clickAndCollect.modals.productAvailabilitySlots") }} <small>*</small></label
                                    >
                                </div>
                                <div class="col-md-7">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="radio">
                                                <label class="form-label container-box"
                                                    ><input type="radio" v-model="deliveryDefaultSlots" :value="true" />
                                                    <span class="checkmark"></span>{{ $tl("labels.useDefaultParams") }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 d-inline radio mt-1">
                                            <label class="form-label container-box d-inline-block pt-0 mt-2" style="width: initial"
                                                ><input type="radio" v-model="deliveryDefaultSlots" :value="false" /> <span class="checkmark"></span
                                                >{{ $tl("labels.custom") }}
                                            </label>
                                        </div>
                                        <ShowErrors class="col-12" :errors="errors" errorKey="use_default_delivery_slots" />
                                    </div>
                                </div>
                            </div>
                            <template v-if="!deliveryDefaultSlots">
                                <div class="row mt-3">
                                    <div class="offset-1 col-11 pt-2">
                                        <div v-for="day in allDays" :key="day">
                                            <div class="mb-2">
                                                <label class="form-label container-box" style="margin-bottom: 0; width: 100%">
                                                    <input type="checkbox" v-model="deliveryActive[day]" />
                                                    <span class="checkmark"></span> {{ dayLabel(day, true) }}
                                                </label>
                                            </div>
                                            <div class="setting-open" v-if="deliveryActive[day]">
                                                <div class="setting-hours">
                                                    <span v-for="slot in deliverySlots[day]" :key="slot.id" class="d-block">
                                                        <label class="form-label container-box ms-4" style="width: initial">
                                                            <input type="checkbox" v-model="slot.enabled" />
                                                            <span class="checkmark"></span>&nbsp;{{
                                                                slot.hour_start.substr(0, 5).replace(":", "h")
                                                            }}
                                                            - {{ slot.hour_end.substr(0, 5).replace(":", "h") }}
                                                        </label>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>

            <template>
                <div class="row mb-3" v-for="(productComponent, index) in product.cc_product_components.data" :key="productComponent.id">
                    <div class="col-12">
                        <div class="border-light b-radius-20 p-4">
                            <div class="row">
                                <div class="col-12 pt-1 d-flex justify-content-between align-items-center">
                                    <div>
                                        <span class="d-block">{{ productComponent.name }}</span>
                                        <small class="text-muted" v-if="productComponent.is_mandatory">{{
                                            $tl("labels.clickAndCollect.modals.mandatoryChoiceForCustomer")
                                        }}</small>
                                        <small class="text-muted" v-else>{{ $tl("labels.optional") }}</small>
                                    </div>
                                    <div>
                                        <button
                                            class="btn btn-sm btn-success btn-square"
                                            title="Modifier la réservation"
                                            @click="updateProductComponent(index, productComponent)"
                                            v-tooltip="getTooltip($tl('labels.form.actions.edit'))">
                                            <feather type="edit" />
                                        </button>
                                        <button
                                            class="btn btn-sm btn-danger btn-square"
                                            @click="deleteProductComponent(index)"
                                            v-tooltip="getTooltip($tl('labels.form.actions.delete'))">
                                            <feather type="trash-2" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <table class="table table-sm table-striped border-bottom mt-2">
                                <thead class="border-bottom">
                                    <tr>
                                        <th>{{ $tl("labels.form.name") }}</th>
                                        <th>{{ $tl("labels.price") }}</th>
                                        <th>{{ $tl("labels.form.actions.title") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(productOption, indexOption) in productComponent.cc_product_options.data" :key="`${indexOption}`">
                                        <td>{{ productOption.cc_product.name }}</td>
                                        <td>
                                            {{ productOption.include ? "Inclus" : formatCurrency(productOption.price) }}
                                        </td>
                                        <td>
                                            <button
                                                class="btn btn-sm btn-warning btn-square"
                                                @click="deleteProductComponentOption(productComponent, indexOption)"
                                                v-tooltip="getTooltip($tl('labels.form.actions.remove'))">
                                                <feather type="x" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <ShowErrors class="d-block" :errors="errors" :errorKey="`product_components.${index}.*`" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button v-if="product.type === 'menu'" @click="addProductComponent" class="btn btn-sm btn-success btn-circle mt-1">
                            <feather type="plus" />
                            {{ $tl("labels.clickAndCollect.modals.addFormulaComponent") }}
                        </button>
                        <button
                            v-else-if="product.type === 'single' && product.cc_product_components.data.length === 0"
                            @click="addProductComponentExtras"
                            class="btn btn-sm btn-success btn-circle mt-1">
                            <feather type="plus" />
                            {{ $tl("labels.clickAndCollect.modals.addOptions") }}
                        </button>
                    </div>
                </div>
            </template>

            <add-click-and-collect-add-formule-component-modal
                v-if="showAddClickAndCollectAddFormuleComponentModal"
                @close="showAddClickAndCollectAddFormuleComponentModal = false"
                @saved="productComponentSaved"
                :productComponent="productComponent" />
        </div>
    </div>
</template>

<script>
import LoaderComponent from "../../components/LoaderComponent";
import ImageUploader from "../../components/forms/ImageUploaderComponent.vue";
import ShowErrors from "../errors/ShowErrors";
import addClickAndCollectAddFormuleComponentModal from "../../components/Modals/clickAndCollect/addClickAndCollectAddFormuleComponentModal";
import VueTimepicker from "vue2-timepicker";
import Datepicker from "vuejs-datepicker";
import { fr } from "vuejs-datepicker/dist/locale";
import axios from "axios";
import moment from "moment";
import StockTypeEnum from "../../mixins/enums/click_and_collect/StockTypeEnum";

function defaultOption() {
    return {
        id: null,
        name: null,
        include: 1,
        price: null,
        tax_rate: null,
    };
}

function defaultComponent(is_extra_forced = false) {
    return {
        id: null,
        name: null,
        order: null,
        is_mandatory: 1,
        is_extra_forced,
        cc_product_options: {
            data: [],
        },
    };
}

export default {
    data() {
        return {
            fr,
            loading: 0,
            errors: null,
            productPreparationTime: this.product.preparation_time !== null,
            productDeliveryPreparationTime: this.product.delivery_preparation_time !== null,
            productAvailabilityDate: this.product.available_from !== null && this.product.available_to !== null,
            productDeliveryAvailabilityDate: this.product.delivery_available_from !== null && this.product.delivery_available_to !== null,
            showAddFormuleAddModal: false,
            showAddClickAndCollectAddFormuleComponentModal: false,
            product_stock_nolimit: this.product.stock === null,
            defaultSlots: this.product.use_default_slots ? true : false,
            deliveryDefaultSlots: this.product.use_default_delivery_slots ? true : false,
            option: null,
            type: null,
            custom_category_name: null,
            services: null,
            deliverySlots: null,
            products_categories: null,
            active: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
            },
            deliveryActive: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
            },
            product_type: false,
            productComponent: null,
            productComponentIndex: null,
            showCollectParams: true,
            showDeliveryParams: true,
            allDays: [1, 2, 3, 4, 5, 6, 0],
        };
    },
    mixins: [StockTypeEnum],
    props: {
        product: {
            type: Object,
            required: true,
        },
        duplicate: {
            type: Boolean,
            default: false,
        },
        config: {
            type: Object,
            required: true,
        },
    },
    computed: {
        restaurantId() {
            return Number.parseInt(this.$route.params.restaurant_id);
        },
        restaurant() {
            return this.$store.getters["restaurants/findRestaurantById"](this.restaurantId);
        },
        hasMealVouchersEnabled() {
            if (!this.restaurant) return false;
            return this.restaurant.edenred_enabled;
        },
        isTvaDisabled() {
            return this.$store.getters["restaurants/isTvaDisabled"](this.restaurantId);
        },
        disabledDates() {
            return {};
        },
        imgPostUri() {
            let uri = `/api/click_and_collect/${this.restaurantId}/products/img`;

            if (this.product.id !== null) {
                uri += `/${this.product.id}`;
            }

            return uri;
        },
    },
    methods: {
        isAllergenActive(allergen) {
            return this.product.allergens.includes(allergen);
        },
        toggleAllergen(allergen) {
            if (this.product.allergens.includes(allergen)) this.product.allergens.splice(this.product.allergens.indexOf(allergen), 1);
            else this.product.allergens.push(allergen);
        },
        dateObjToIsoDate(date) {
            if (!date) return null;
            return moment(date).format("Y-MM-DD");
        },
        getNextOrder() {
            let order = 0;
            this.product.cc_product_components.data.forEach((component) => {
                if (component.order > order) order = component.order;
            });
            return parseInt(order) + 1;
        },
        addProductComponent() {
            this.productComponent = defaultComponent();
            this.productComponent.order = this.getNextOrder();
            this.productComponentIndex = null;
            this.showAddClickAndCollectAddFormuleComponentModal = true;
        },
        addProductComponentExtras() {
            this.productComponent = defaultComponent(true);
            this.productComponent.name = "Suppléments";
            this.productComponent.order = 1;
            this.productComponent.is_mandatory = 0;
            this.productComponentIndex = null;
            this.showAddClickAndCollectAddFormuleComponentModal = true;
        },
        updateProductComponent(index, productComponent) {
            this.productComponent = _.cloneDeep(productComponent);
            this.productComponentIndex = index;
            this.showAddClickAndCollectAddFormuleComponentModal = true;
        },
        productComponentSaved() {
            this.showAddClickAndCollectAddFormuleComponentModal = false;
            if (this.productComponentIndex === null) this.product.cc_product_components.data.push(this.productComponent);
            else this.product.cc_product_components.data.splice(this.productComponentIndex, 1, this.productComponent);
            this.product.cc_product_components.data.sort((a, b) => a.order - b.order);
        },
        deleteProductComponent(index) {
            if (!confirm(this.$tl("labels.clickAndCollect.modals.confirmDeleteMenuComponent"))) return;
            this.product.cc_product_components.data.splice(index, 1);
        },
        deleteProductComponentOption(productComponent, index) {
            productComponent.cc_product_options.data.splice(index, 1);
        },
        getFormattedData() {
            const data = _.cloneDeep(this.product);

            Object.assign(data, {
                unlimited_stock: this.product_stock_nolimit,
                use_default_preparation_time: !this.productPreparationTime,
                available_always: !this.productAvailabilityDate,
                delivery_use_default_preparation_time: !this.productDeliveryPreparationTime,
                delivery_available_always: !this.productDeliveryAvailabilityDate,
                custom_category_name: this.custom_category_name,
                img: data.img !== null ? data.img.path : null,
            });

            data.product_components = [];
            data.cc_product_components.data.forEach((productComponent) => {
                for (let i = 0; i < productComponent.cc_product_options.data.length; i++) {
                    if (productComponent.cc_product_options.data[i].price !== null && !isNaN(productComponent.cc_product_options.data[i].price))
                        productComponent.cc_product_options.data[i].price = productComponent.cc_product_options.data[i].price * 100;
                }
                data.product_components.push(productComponent);
            });

            data.use_default_slots = this.defaultSlots;
            data.use_default_delivery_slots = this.deliveryDefaultSlots;
            data.price = data.price === null ? null : data.price * 100;
            data.price_offer = data.price_offer === null ? null : data.price_offer * 100;
            data.available_from = this.dateObjToIsoDate(data.available_from);
            data.available_to = this.dateObjToIsoDate(data.available_to);
            data.delivery_available_from = this.dateObjToIsoDate(data.delivery_available_from);
            data.delivery_available_to = this.dateObjToIsoDate(data.delivery_available_to);
            data.offer_starts_on = data.offer_starts_on ? moment(data.offer_starts_on).format("Y-MM-DD") : null;
            data.offer_ends_on = data.offer_ends_on ? moment(data.offer_ends_on).format("Y-MM-DD") : null;

            if (!data.use_default_slots) {
                data.cc_services = this.services;
                data.services_active = this.active;
            }

            if (!data.use_default_delivery_slots) {
                data.cc_delivery_slots = [];
                Object.keys(this.deliverySlots).forEach((day) => {
                    if (this.deliveryActive[day]) {
                        this.deliverySlots[day].forEach((slot) => {
                            if (slot.enabled)
                                data.cc_delivery_slots.push({
                                    day,
                                    id: slot.id,
                                });
                        });
                    }
                });
            }

            return data;
        },
        save() {
            this.loading++;
            this.errors = null;

            if (this.product.id === null) {
                axios
                    .post(`/api/click_and_collect/${this.restaurantId}/products`, this.getFormattedData())
                    .then((response) => {
                        this.loading--;
                        this.$notify({
                            group: "notification",
                            type: "success",
                            title: response.data.message,
                        });
                        this.$emit("saved");
                    })
                    .catch((error) => {
                        this.loading--;
                        this.errors = error.response.data.errors;
                        this.$notify({
                            group: "notification",
                            type: "error",
                            title: error.response.data.message ? error.response.data.message : this.$tl("errors.common.unknown"),
                        });
                    });
            } else {
                axios
                    .put(`/api/click_and_collect/${this.restaurantId}/products/${this.product.id}`, this.getFormattedData())
                    .then((response) => {
                        this.loading--;
                        this.$notify({
                            group: "notification",
                            type: "success",
                            title: response.data.message,
                        });
                        this.$emit("saved");
                    })
                    .catch((error) => {
                        this.loading--;
                        this.errors = error.response.data.errors;
                        this.$notify({
                            group: "notification",
                            type: "error",
                            title: error.response.data.message ? error.response.data.message : this.$tl("errors.common.unknown"),
                        });
                    });
            }
        },
        fetchProduct() {
            this.loading++;

            return axios
                .get(`/api/click_and_collect/${this.restaurantId}/products/spec/${this.product.id}`)
                .then((response) => {
                    this.loading--;

                    _.assignIn(this.product, response.data);

                    if (this.duplicate) {
                        this.product.id = null;
                        this.product.img = null;
                    }

                    return true;
                })
                .catch((error) => {
                    this.loading--;
                    this.$notify({
                        group: "notification",
                        type: "error",
                        title: error.response.data.message ? error.response.data.message : this.$tl("errors.common.unknown"),
                    });
                    return false;
                });
        },
        fetchProductsCategories() {
            this.loading++;

            axios
                .get(`/api/click_and_collect/${this.restaurantId}/products/categories`)
                .then((response) => {
                    this.loading--;
                    this.products_categories = response.data.data;
                })
                .catch((error) => {
                    this.loading--;
                    this.$notify({
                        group: "notification",
                        type: "error",
                        title: error.response.data.message ? error.response.data.message : this.$tl("errors.common.unknown"),
                    });
                });
        },
        fetchAllServices() {
            this.loading++;

            axios
                .get(`/api/click_and_collect/${this.restaurantId}/products/services`)
                .then((response) => {
                    this.services = {};
                    this.allDays.forEach((day) => {
                        this.services[day] = response.data.cc_services.filter((service) => day === service.day);
                        if (this.product.id !== null || this.duplicate)
                            for (let j = 0; j < this.services[day].length; j++)
                                for (let i = 0; i < this.services[day][j].slots.length; i++)
                                    this.services[day][j].slots[i].enabled = this.product.cc_product_slots.data.some(
                                        (slot) => slot.cc_slot_id === this.services[day][j].slots[i].id
                                    )
                                        ? 1
                                        : false;
                        this.active[day] = this.services[day].some((service) => service.slots.some((slot) => slot.enabled));
                    });
                    this.deliverySlots = {};
                    this.allDays.forEach((day) => {
                        this.deliverySlots[day] = response.data.cc_delivery_slots.filter((s) => day === s.day);
                        for (let j = 0; j < this.deliverySlots[day].length; j++)
                            this.deliverySlots[day][j].enabled = this.product.cc_product_delivery_slots.data.some(
                                (s) => s.id === this.deliverySlots[day][j].id
                            );
                        this.deliveryActive[day] = this.deliverySlots[day].some((s) => s.enabled);
                    });
                    setTimeout(() => {
                        this.loading--;
                    }, 50);
                })
                .catch((error) => {
                    this.loading--;
                    let errorMsg = this.$tl("errors.common.unknown");
                    if (error.response && error.response.data.message) errorMsg = error.response.data.message;
                    else if (error.message) errorMsg = error.message;
                    this.$notify({
                        group: "notification",
                        type: "error",
                        title: errorMsg,
                    });
                });
        },
    },
    watch: {
        product_stock_nolimit(newVal) {
            if (newVal) this.product.stock = null;
        },
    },
    components: {
        LoaderComponent,
        ImageUploader,
        VueTimepicker,
        ShowErrors,
        Datepicker,
        addClickAndCollectAddFormuleComponentModal,
    },
    created() {
        this.fetchProductsCategories();
        if (this.product.id) {
            this.fetchProduct().then((result) => {
                if (result) this.fetchAllServices();
            });
        } else {
            this.fetchAllServices();
        }
    },
};
</script>
